<form style="height: 100%;">
    <div class="verify_number_heading">
        <h5>Verify WhatsApp No</h5>
    </div>
    <div fxLayout="row" fxLayout.lt-sm="column" style="margin-left: 13%; margin-right: 13%; margin-top: 2%">
        <mat-card class="contain_card" fxFlex="98">
            <mat-form-field class="example-full-width">
                <input required matInput maxlength="10" placeholder="WhatsApp Number" [value]="mobileNo" readonly />
            </mat-form-field>
        </mat-card>
    </div>

    <div *ngIf="showHideSendOtpDiv" fxLayout="row" fxLayout.lt-sm="column" style="margin-left: 13%;">
        <button type="button" style="margin-top: 10px; width: 50%;" mat-button class="md-raised md-primary pull-left"
            id="btn-amt-black-ok" (click)="sendOtpClick()">
            SEND OTP
        </button>
    </div>

    <div *ngIf="showHideOtpDiv" fxLayout="column" style="margin-left: 13%; margin-right: 13%; margin-top: 2%">
        <mat-card class="contain_card" fxFlex="98">
            <mat-form-field class="example-full-width">
                <input required matInput maxlength="10" placeholder="Enter Otp" (keyup)="checkOtp($event.target.value)"
                    autocomplete="off" />
            </mat-form-field>
        </mat-card>
        <div style="margin-top: 5px; margin-bottom: 5px; text-align: center; font-size: 11px;">
            Didn't Receive OTP?
            <span style="text-align: center; color: #4285f4; cursor: pointer" (click)="reSendOtpClick()">
                RESEND OTP</span>
        </div>
    </div>
</form>